import styled from 'styled-components';

export const Container = styled.div`
  background: ${(props) => props.theme.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  transition: box-shadow 0.3s;
  overflow: hidden;
  border-radius: 8px;
  border: 3px solid var(--Gray-gray-100, #d4d6db);

  width: 100%;
  max-width: 20rem;

  :hover::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    background: linear-gradient(240deg, #2469a8, #f8b700, #c61722);
    z-index: -1;
    margin: -2px;
    border-radius: 5px;
    transition: display 5s;
    background-size: 300% 300%;
    animation: colors 8s ease infinite;
  }
  @keyframes colors {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    background: #e6ebef;

    button {
      border: none;
      background: none;
      font-size: 1rem;
      transition: color 0.3s;
      color: #40444c;
      padding-right: 0.75rem;
      height: 60px;
      :hover {
        color: ${(props) => props.theme.primary};
      }
    }
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  :hover::before {
    background: white;
  }

  .contentGraphicValue {
    margin-left: 2px;
    margin-top: 1.5rem;
    margin-bottom: -4.5rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    h6 {
      position: absolute;
      margin-top: -35px;
      font-size: 1rem;
      font-weight: 500;
      color: #40444c;
      font-family: Poppins;
      font-size: 19.511px;
      font-style: normal;
      font-weight: 600;
      line-height: 150%;
    }
  }
  h5 {
    margin-bottom: 1rem;
    font-weight: 500;
    font-size: 1.25rem;
    color: ${(props) => props.theme['gray-400']};
    padding: 0 0.5rem;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
`;

export const ImageContent = styled.div`
  background: ${(props) => props.theme.white};
  padding: 0.25rem;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 2%;

  img {
    border-radius: 50%;
    width: 3.125rem;
  }
`;
